export default __webpack_public_path__ + "assets/mailbox-ef064a6f7425dd1a5fbdbe646fb32ebc.png";